import type { RequestParams } from '@/shared/api';

export const PURCHASE_KEYS = {
  all: ['purchase'] as const,
  list: (params?: RequestParams) => [...PURCHASE_KEYS.all, 'list', params] as const,
  detail: (groupId: string) => [...PURCHASE_KEYS.all, 'detail', groupId] as const,
};
